var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import Spinner from 'react-bootstrap/Spinner';
export const dropdownStyle = {
    control: (base, state) => (Object.assign(Object.assign({}, base), { height: 'calc(1.5em + 0.94rem + 2px)', minHeight: '1.5em', border: '1px solid #BCBCBC', borderRadius: 6, boxShadow: state.isFocused ? '0 0 0 0.15rem rgba(246, 153, 6, 0.25);' : '0', alignContent: 'center' })),
    menu: (base) => (Object.assign(Object.assign({}, base), { zIndex: 9999, paddingLeft: 8 })),
    placeholder: (base, state) => (Object.assign(Object.assign({}, base), { color: '#919bae' })),
    valueContainer: (base) => (Object.assign(Object.assign({}, base), { flexWrap: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' })),
    option: (base, state) => (Object.assign(Object.assign({}, base), { padding: 0, whiteSpace: 'pre', backgroundColor: state.isSelected || state.isFocused ? '#f69906' : 'transparent', color: state.isSelected || state.isFocused ? '#fff' : 'inherit' })),
    dropdownIndicator: (base) => (Object.assign(Object.assign({}, base), { color: 'black', paddingTop: 0, paddingBottom: 0 })),
    clearIndicator: (base) => (Object.assign(Object.assign({}, base), { paddingTop: 0, paddingBottom: 0, margin: 0 }))
};
export const dropdownColorTheme = (theme) => (Object.assign(Object.assign({}, theme), { colors: Object.assign(Object.assign({}, theme.colors), { primary25: 'rgba(#f69906, .25)', primary50: 'rgba(#f69906, .50)', primary75: 'rgba(#f69906, .75)', primary: '#f69906' }) }));
const LoadingSpinner = () => (_jsx(Spinner, { animation: 'border', variant: 'dark', size: 'sm' }));
export const Dropdown = forwardRef((_a, ref) => {
    var { isInvalid, label, options, setValue, value, onChange, readOnly, disabled, isLoading } = _a, rest = __rest(_a, ["isInvalid", "label", "options", "setValue", "value", "onChange", "readOnly", "disabled", "isLoading"]);
    const isMulti = useMemo(() => rest.type.toLowerCase().includes('multi'), [rest.type]);
    const optionList = useMemo(() => {
        if (!options || options.length === 0) {
            return [];
        }
        return typeof (options === null || options === void 0 ? void 0 : options[0]) === 'string' || typeof (options === null || options === void 0 ? void 0 : options[0]) === 'number'
            ? options.map((o) => ({
                value: !isNaN(Number(o)) ? Number(o) : o,
                label: o.toString()
            }))
            : options || [];
    }, [options]);
    const selectedValue = useMemo(() => {
        if (isMulti) {
            return Array.isArray(value)
                ? optionList.filter((o) => value.includes(o.value))
                : [];
        }
        return optionList.find((o) => o.value === value) || '';
    }, [optionList, value, rest.type]);
    const handleChange = useCallback((valueObj) => {
        if (isMulti) {
            return setValue === null || setValue === void 0 ? void 0 : setValue(rest.name, [...value, ...valueObj.map((v) => v.value)], {
                shouldValidate: true,
                shouldDirty: true,
                shouldTouch: true
            });
        }
        setValue === null || setValue === void 0 ? void 0 : setValue(rest.name, valueObj.value, {
            shouldValidate: true,
            shouldDirty: true,
            shouldTouch: true
        });
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(Form.Label, Object.assign({ htmlFor: rest.name }, { children: label })), _jsx(Select, Object.assign({}, rest, { id: rest.name, name: rest.name, isLoading: isLoading, isDisabled: readOnly || isLoading || disabled, onChange: handleChange, value: selectedValue, hideSelectedOptions: false, isSearchable: true, isMulti: isMulti, options: optionList, placeholder: label, components: {
                    IndicatorSeparator: () => null,
                    LoadingIndicator: LoadingSpinner
                }, styles: dropdownStyle, theme: dropdownColorTheme, classNames: {
                    control: () => (isInvalid ? 'field-error' : '')
                } }))] }));
});
Dropdown.displayName = 'Dropdown';
